import { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import {
  // Col,
  Button,
  InputNumber,
  Row,
  message,
} from 'antd'
import * as turf from '@turf/turf'
import * as Cesium from '@cesiumgs/cesium-analytics'
import Modal from '@/components/Modal'
import useStore from '@/hooks/useStore'
import { ME4_MODAL_TITLE, MODAL_WIDTH350 } from '@/components/Content/RightNavCtrl/data'
import Draw from '@/components/Cesium/Draw/Draw'
import { word2Lnglat } from '@/components/Cesium/CartesianOrWkt'
import { DrawType } from '@/components/Cesium/Draw/DrawType'

import { DrawEventType } from '@/components/Cesium/Draw/DrawEventType'
import { rightNavContext } from '@/components/Content/RightNavCtrl/RightNavCtrl'

import './index.less'

let drawTool: any = null
const ENTITY_NAME = 'volume-measure'
const prefix = 'volumeMeasure'
function VolumeMeasure() {
  const measureStore = useStore('measureStore')
  const volumeStore = useStore('volumeStore')
  const rightNavCtrlStore = useStore('rightNavCtrlStore')
  const uiStore = useStore('uiStore')
  const rightContext = useContext(rightNavContext)
  const { viewer } = rightContext
  const [messageApi, contextHolder] = message.useMessage()
  const [visible, setVisible] = useState(true)
  const [heightData, setHeightData] = useState<number | null>(null)
  useEffect(() => {
    return () => {
      handleClear()
    }
  }, [])

  const renderModalTitle = () => {
    return ME4_MODAL_TITLE
  }

  const renderModalWidth = () => {
    return MODAL_WIDTH350
  }

  const drawHeight = () => {
    const obj = {
      viewer,
      callback: (res: number) => {
        setHeightData(res)
      },
    }
    volumeStore.drawTrianglesMeasureGraphicsVolume(obj)
  }

  const heightChange = (value: number | null) => {
    setHeightData(value)
  }

  const drawLabel = () => {
    if (heightData === null) {
      messageApi.warning('먼저 높이를 측정해주세요')
    }
    else {
      const draw = new Draw(viewer)
      drawTool = draw
      viewer.entities.removeAll()
      viewer.dataSources.remove(
        viewer.dataSources.getByName(ENTITY_NAME)[0],
      )
      const height = heightData
      const action = drawTool.create(DrawType.Polygon, {
        useDefaultEntity: true,
      })
      action.on(DrawEventType.VertexAdd, (evt: any) => {})
      action.on(DrawEventType.Complete, (evt: any) => {
        evt.push(evt[0])
        const Arr = word2Lnglat(viewer, evt)
        const polygon = turf.polygon([Arr])
        const area = turf.area(polygon)
        const center = turf.centerOfMass(polygon)
        Cesium.GeoJsonDataSource.load(polygon.geometry).then((
          dataSource,
        ) => {
          dataSource.name = ENTITY_NAME
          viewer.dataSources.add(dataSource)
          const entities = dataSource.entities.values
          for (let i = 0; i < entities.length; i++) {
            const entity: any = entities[i]
            entity.polygon.heightReference
              = Cesium.HeightReference.RELATIVE_TO_GROUND
            entity.polygon.extrudedHeightReference
              = Cesium.HeightReference.RELATIVE_TO_GROUND
            entity.polygon.material = new Cesium.Color(
              204 / 255,
              247 / 255,
              217 / 255,
              0.6,
            )
            entity.polygon.outline = true
            entity.polygon.height = 0
            entity.polygon.extrudedHeight = height
            entity.polygon.outlineColor = Cesium.Color.YELLOW
          }
        })
        const lon = center.geometry.coordinates[0]
        const lat = center.geometry.coordinates[1]
        viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(lon, lat, height + 5),
          point: {
            show: false,
          },
          label: {
            text: `체적${(area * height).toFixed(2)}m³`,
            font: '13pt Source Han Sans CN',
            showBackground: true,
            backgroundColor:
              Cesium.Color.fromCssColorString('#001f33').withAlpha(0.6),
            style: Cesium.LabelStyle.FILL,
            fillColor: Cesium.Color.fromCssColorString('#ffffff'),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            outlineWidth: 5,
            outlineColor:
              Cesium.Color.fromCssColorString('#001f33').withAlpha(0.2),
            verticalOrigin: Cesium.VerticalOrigin.TOP,
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            pixelOffset: new Cesium.Cartesian2(-21, -30),
          },
        })
        // setVisible(false)
      })
    }
  }

  const handleClear = () => {
    volumeStore.destroy()
    viewer.entities.removeAll()
    viewer.dataSources.removeAll()
  }
  return (
    <div className={`${prefix}`}>
      {contextHolder}
      <Modal
        visible={visible}
        headerTitle={renderModalTitle()}
        handleClose={() => {
          setVisible(false)
          measureStore.setIsClosedMeasure(true)
          rightNavCtrlStore.setCurrentVisible(undefined)
        }}
        styles={{
          position: 'fixed',
          width: renderModalWidth(),
          top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
          left: `${uiStore.Content_Left_Width + 30}px`,
          zIndex: 10,
        }}
      >
        <Row>
          <Row align="middle" className={`${prefix}-one`} gutter={16}>
            높이:
            <InputNumber
              addonAfter={
                <div style={{ cursor: 'pointer' }} onClick={drawHeight}>
                  높이 측정
                </div>
              }
              onChange={heightChange}
              style={{ marginLeft: '12px' }}
              value={heightData}
            ></InputNumber>
          </Row>
          <Row className={`${prefix}-btn`}>
            <Button onClick={drawLabel} className={`${prefix}-btn-sure`}>
              부피 측정
            </Button>
            <Button onClick={handleClear} className={`${prefix}-btn-cancel`}>
              삭제
            </Button>
          </Row>
        </Row>
      </Modal>
    </div>
  )
}
export default observer(VolumeMeasure)
